import { apiFetch } from './core'

export async function fetchPrestations(filters = {}) {
  const params = new URLSearchParams()
  if (filters.customerId) params.set('customer_id', filters.customerId)
  if (filters.projectId) params.set('project_id', filters.projectId)
  if (filters.status) params.set('status', filters.status)
  if (filters.paymentMode) params.set('payment_mode', filters.paymentMode)
  if (filters.search) params.set('search', filters.search)
  if (filters.overdue) params.set('overdue', 'true')
  if (filters.sortBy) params.set('sort_by', filters.sortBy)
  if (filters.sortOrder) params.set('sort_order', filters.sortOrder)

  const url = `/api/prestations${params.toString() ? '?' + params : ''}`
  return apiFetch(url)
}

export async function fetchPrestationsKpis(filters = {}) {
  const params = new URLSearchParams()
  if (filters.from) params.set('from', filters.from)
  if (filters.to) params.set('to', filters.to)

  const url = `/api/prestations/kpis${params.toString() ? '?' + params : ''}`
  return apiFetch(url)
}

export async function fetchPrestation(id) {
  return apiFetch(`/api/prestations/${id}`)
}

export async function createPrestation(data) {
  return apiFetch('/api/prestations', {
    method: 'POST',
    body: data,
  })
}

export async function updatePrestation(id, data) {
  return apiFetch(`/api/prestations/${id}`, {
    method: 'PATCH',
    body: data,
  })
}

export async function changePrestationStatus(id, status, reason) {
  return apiFetch(`/api/prestations/${id}/change-status`, {
    method: 'POST',
    body: { status, reason },
  })
}

export async function createPaymentPlan(prestationId, installments) {
  return apiFetch(`/api/prestations/${prestationId}/create-payment-plan`, {
    method: 'POST',
    body: { installments },
  })
}

export async function recordPayment(prestationId, installmentId, amount) {
  return apiFetch(`/api/prestations/${prestationId}/record-payment`, {
    method: 'POST',
    body: { installment_id: installmentId, amount },
  })
}

export async function recordDirectPayment(prestationId, paymentData) {
  return apiFetch(`/api/prestations/${prestationId}/payments`, {
    method: 'POST',
    body: paymentData,
  })
}

export async function fetchPrestationPayments(prestationId) {
  return apiFetch(`/api/prestations/${prestationId}/payments`)
}

export async function generatePrestationQuote(prestationId) {
  return apiFetch(`/api/prestations/${prestationId}/generate-quote`, {
    method: 'POST',
  })
}

export function getPrestationPdfUrl(prestationId) {
  return `/api/prestations/${prestationId}/pdf`
}
